const HTML_MARKER_REGEXP = /<(?:!doctype|html|body|head|div|span|table|img|font|center|h[1-6]|ul|ol|style|section|header|footer|figure)\b/i

export default class extends HTMLElement {
  connectedCallback () {
    this.input = this.querySelector('markdown-editor input[type="hidden"]')
    this.markdownEditor = this.querySelector('markdown-editor')
    this.textPanel = this.querySelector('[data-role="text-panel"]')
    this.htmlPanel = this.querySelector('[data-role="html-panel"]')
    this.codePanel = this.querySelector('[data-role="code-panel"]')
    this.previewPanel = this.querySelector('[data-role="preview-panel"]')
    this.codeInput = this.querySelector('[data-role="code-input"]')
    this.previewIframe = this.querySelector('[data-role="preview-iframe"]')
    this.textModeButton = this.querySelector('[data-role="text-mode"]')
    this.htmlModeButton = this.querySelector('[data-role="html-mode"]')
    this.previewTab = this.querySelector('[data-role="preview-tab"]')
    this.codeTab = this.querySelector('[data-role="code-tab"]')

    if (!this.input) return

    this.codeInput.value = this.input.value

    this.textModeButton.addEventListener('click', this.showTextMode)
    this.htmlModeButton.addEventListener('click', this.showHtmlMode)
    this.previewTab.addEventListener('click', this.showPreview)
    this.codeTab.addEventListener('click', this.showCode)
    this.codeInput.addEventListener('input', this.onCodeInput)
    this.input.addEventListener('input', this.onTextInput)

    if (HTML_MARKER_REGEXP.test(this.input.value)) {
      this.setMode('html')
      this.setHtmlView('preview')
    } else {
      this.setMode('text')
      this.setHtmlView('code')
    }
  }

  disconnectedCallback () {
    this.textModeButton?.removeEventListener('click', this.showTextMode)
    this.htmlModeButton?.removeEventListener('click', this.showHtmlMode)
    this.previewTab?.removeEventListener('click', this.showPreview)
    this.codeTab?.removeEventListener('click', this.showCode)
    this.codeInput?.removeEventListener('input', this.onCodeInput)
    this.input?.removeEventListener('input', this.onTextInput)
    window.clearTimeout(this.previewTimeout)
  }

  showTextMode = () => {
    this.markdownEditor.setValue?.(this.input.value)
    this.setMode('text')
  }

  showHtmlMode = () => {
    this.codeInput.value = this.input.value
    this.setMode('html')
    this.setHtmlView('code')
  }

  showPreview = () => {
    this.setHtmlView('preview')
  }

  showCode = () => {
    this.setHtmlView('code')
    this.codeInput.focus()
  }

  onCodeInput = () => {
    this.input.value = this.codeInput.value
    this.syncingCode = true
    this.input.dispatchEvent(new Event('input', { bubbles: true }))
    this.syncingCode = false

    window.clearTimeout(this.previewTimeout)
    this.previewTimeout = window.setTimeout(this.updatePreview, 300)
  }

  onTextInput = () => {
    if (!this.syncingCode) this.codeInput.value = this.input.value
  }

  setMode (mode) {
    const htmlMode = mode === 'html'

    this.textPanel.classList.toggle('hidden', htmlMode)
    this.htmlPanel.classList.toggle('hidden', !htmlMode)
    this.setButtonState(this.textModeButton, !htmlMode)
    this.setButtonState(this.htmlModeButton, htmlMode)
  }

  setHtmlView (view) {
    const previewView = view === 'preview'

    this.codePanel.classList.toggle('hidden', previewView)
    this.previewPanel.classList.toggle('hidden', !previewView)
    this.setTabState(this.previewTab, previewView)
    this.setTabState(this.codeTab, !previewView)

    if (previewView) this.updatePreview()
  }

  setButtonState (button, active) {
    button.setAttribute('aria-pressed', active.toString())
    button.classList.toggle('bg-white', active)
    button.classList.toggle('shadow-sm', active)
    button.classList.toggle('text-base-content', active)
    button.classList.toggle('text-base-content/60', !active)
  }

  setTabState (tab, active) {
    tab.setAttribute('aria-selected', active.toString())
    tab.classList.toggle('tab-active', active)
    tab.classList.toggle('tab-bordered', active)
    tab.classList.toggle('pb-[3px]', !active)
  }

  updatePreview = () => {
    this.previewIframe.srcdoc = this.codeInput.value
  }
}
